import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 21 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.167 17.5v-15m16.666 15v-15m-12.5 11.667L8 10.833m0 0 2.5-5 2.5 5m-5 0s.833.834 2.5.834 2.5-.834 2.5-.834m0 0 1.667 3.334"
    />
  </svg>
)
export default SvgComponent
